<template>
  <div>
    <SignIn/>
  </div>
</template>

<script>
import SignIn from "@/components/SignIn.vue";
import FullPageLayout from "../layouts/FullPageLayout";

export default {
  components: {
    SignIn
  },
  created() {
    this.$emit(`update:layout`, FullPageLayout);
  }
};
</script>